module.exports = __webpack_public_path__ + "static/offiziershaeuser-d340134883578418a62f3ad7de57b5ad.PNG";